import status from '../constants/actionStatus'
export default (state = {
    status : status.PENDING,
    subjects : []
}, action = {}) => {
    switch (action.type) {
        case 'SUBJECTS_REQUEST':
            return {
                status : status.PENDING,
                subjects : action.payload
            };
        case 'SUBJECTS_SUCCESS':
            return {
                status : status.SUCCESS,
                subjects : action.payload
            };

        case 'QUESTION_RESPONSE_SUCCESS':
            try{
                let questionResponse = action.payload;
                let subjects = state.subjects.map((subject)=>{
                    subject = {...subject}; // copy
                    if(subject._id === questionResponse.subjectId){
                        subject.attemptedQuesCount = subject.attemptedQuesCount + 1;
                        subject.topics = subject.topics.map((topic) =>{
                            topic = {...topic}; // copy
                            if(topic._id === questionResponse.topicId){
                                topic.attempted = topic.attempted + 1;
                                return topic;
                            }
                            return topic;
                        });
                    }
                    return subject;
                });
                return {
                    status : status.SUCCESS,
                    subjects: subjects
                };
            }catch (e) {
                return state;
            }

        case 'SUBJECTS_FAILURE':
            return {
                status : status.ERROR,
                subjects : []
            };
        default:
            return state
    }
}

